import axios from 'axios'

import { log, token } from './interceptors'

const apiUrl = process.env.REACT_APP_URL + '/api/v2'
const instance = axios.create({
	baseURL: apiUrl,
	headers: {},
	data: {},
	timeout: 300000,
})

token(instance)
log(instance)
export default instance
